import { render, staticRenderFns } from "./bill-back.vue?vue&type=template&id=11554ef4"
import script from "./bill-back.vue?vue&type=script&lang=js"
export * from "./bill-back.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports